import Route from '@ember/routing/route';
import { get, set } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  contactsCache: service(),
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Groups');
  },

  model() {
    let items = [];
    let groupContacts = get(this, 'contactsCache.groupContacts');
    Object.keys(groupContacts).forEach((group) => {
      items.push({ group: group, contacts: groupContacts[group].contacts });
    });
    return items;
  },
});
